"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamUtils = void 0;
const types_1 = require("../team/types");
const DEFAULT_SUFFIX = 'default_hidden_team';
/**
 * @name TeamUtils
 * @description A class which exports some static utility functions to aid in any CRUD operations on Team model
 */
class TeamUtils {
    /**
     * @description A utility method to get the default name of the team (which is going to be hidden to the end user)
     * @param organisation The organisation that we want to create the default team for
     * @returns {string} The name of the default team
     */
    static getDefaultTeamName(organisation) {
        const { name } = organisation;
        return `${name}_${DEFAULT_SUFFIX}`;
    }
    /**
     * @description Utility method to check if the team is the default team on the basis of the team name
     * @param {IEmTeam | undefined} team - The team of the user
     * @param {IEmOrganisation |undefined } organisation - The organisation of the user
     * @returns {boolean} Boolean
     */
    static isTeamNameDefault(team, organisation) {
        if (team && organisation) {
            const { name: teamName } = team;
            const { name: organisationName } = organisation;
            return teamName === `${organisationName}_${DEFAULT_SUFFIX}`;
        }
        return false;
    }
    /**
     * @description A utility method to check if the team that is passed is default & is supposed to be hidden from the UI
     * @param {IEmTeam | undefined} team - Pass the team here that you want to verify if its hidden & default
     * @returns {boolean} A boolean flag
     */
    static isTeamDefaultAndHidden(team) {
        if (team) {
            const { type } = team;
            return type === types_1.TeamType.DEFAULT;
        }
        return false;
    }
}
exports.TeamUtils = TeamUtils;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVhbS11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy90ZWFtLXV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUdILDJDQUFvRDtBQUVwRCxNQUFNLGNBQWMsR0FBRyxxQkFBcUIsQ0FBQztBQUU3Qzs7O0dBR0c7QUFDSCxNQUFhLFNBQVM7SUFDcEI7Ozs7T0FJRztJQUNJLE1BQU0sQ0FBQyxrQkFBa0IsQ0FBQyxZQUE2QjtRQUM1RCxNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsWUFBWSxDQUFDO1FBQzlCLE9BQU8sR0FBRyxJQUFJLElBQUksY0FBYyxFQUFFLENBQUM7SUFDckMsQ0FBQztJQUVEOzs7OztPQUtHO0lBQ0ksTUFBTSxDQUFDLGlCQUFpQixDQUFDLElBQXlCLEVBQUUsWUFBeUM7UUFDbEcsSUFBSSxJQUFJLElBQUksWUFBWSxFQUFFO1lBQ3hCLE1BQU0sRUFBRSxJQUFJLEVBQUUsUUFBUSxFQUFFLEdBQUcsSUFBSSxDQUFDO1lBQ2hDLE1BQU0sRUFBRSxJQUFJLEVBQUUsZ0JBQWdCLEVBQUUsR0FBRyxZQUFZLENBQUM7WUFDaEQsT0FBTyxRQUFRLEtBQUssR0FBRyxnQkFBZ0IsSUFBSSxjQUFjLEVBQUUsQ0FBQztTQUM3RDtRQUNELE9BQU8sS0FBSyxDQUFDO0lBQ2YsQ0FBQztJQUVEOzs7O09BSUc7SUFDSSxNQUFNLENBQUMsc0JBQXNCLENBQUMsSUFBeUI7UUFDNUQsSUFBSSxJQUFJLEVBQUU7WUFDUixNQUFNLEVBQUUsSUFBSSxFQUFFLEdBQUcsSUFBSSxDQUFDO1lBQ3RCLE9BQU8sSUFBSSxLQUFLLGdCQUFRLENBQUMsT0FBTyxDQUFDO1NBQ2xDO1FBQ0QsT0FBTyxLQUFLLENBQUM7SUFDZixDQUFDO0NBQ0Y7QUF0Q0QsOEJBc0NDIn0=